import { render } from "./UmwaHeader.vue?vue&type=template&id=3d89b864"
import script from "./UmwaHeader.vue?vue&type=script&lang=js"
export * from "./UmwaHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__